import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import VueClipboard from 'vue-clipboard2'
import 'buefy/dist/buefy.css'
import VueAnalytics from 'vue-analytics'

var SocialSharing = require('vue-social-sharing')

Vue.use(VueAnalytics, {
  id: 'UA-141672389-2'
})
Vue.use(SocialSharing)
Vue.use(Buefy, { defaultIconPack: 'fas' })
Vue.use(VueClipboard)
VueClipboard.config.autoSetContainer = true // add this line
Vue.prototype.$liff = window.liff
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
